import React from 'react'
import CustomizedDialogs from './footer-modal';

interface Props { footerStyle: string }
const FooterLinks = (props: Props) => {

  const footerPages = [
    { title: "Cookies Policy", modalId: 1 },
    { title: "Privacy Policy", modalId: 2 },
    { title: "Terms & Conditions", modalId: 3 },
  ];

  const [openModal, setOpenModal] = React.useState(false)
  const [id, setId] = React.useState(0);

  const pagesHandler = (modalId: number) => {
    setId(modalId);
    setOpenModal(true);
  };

  const closeModalHandler = () => setOpenModal(false);

  return (
    <>
      <ul>
        {footerPages.map((item, index) => {
          return (
            <li key={index} className={`${props.footerStyle} fs-14 cursor-pointer`} onClick={() => pagesHandler(item.modalId)}>{item.title}</li>
          )
        })}
      </ul>
      
      <CustomizedDialogs close={closeModalHandler} open={openModal} id={id} />
    </>
  )
}

export default FooterLinks